// Audit Profile page (Feb 2026 v3) — questions-only.
//
// Renders the V2 panel and nothing else. Master + custom questions
// come from /api/audit-profile-v2. Each question exposes a text field,
// an upload button, and a direct Archive/Unarchive button. The Test
// Credentials system row keeps its encrypted structured table.
import React from 'react';
import Header from '../Header';
import AuditProfileV2Panel from './AuditProfileV2Panel';
import { useAuth } from '../../App';

const AuditProfilePage = () => {
  const { currentWorkspace } = useAuth();
  const role = currentWorkspace?.role || '';

  return (
    <div className="min-h-screen bg-appbg" data-testid="audit-profile-page">
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <AuditProfileV2Panel workspaceRole={role} />
      </div>
    </div>
  );
};

export default AuditProfilePage;
